import { simplifyPoints } from "../../simplifyPoints";

const ELEVATION_THRESHOLDS = {
  100: 0.00025,
  50: 0.00005,
  25: 0.0001,
  10: 0.0003,
};

const _ELEVATION_THRESHOLDS = {
  100: 0.00025,
  50: 0.0002,
  25: 0.00015,
  10: 0.0001,
};

const getThreshold = (distance, thresholds) => {
  const sortedKeys = Object.keys(thresholds)
    .map(Number) // Convert keys to numbers
    .sort((a, b) => b - a); // Sort in descending order

  for (const key of sortedKeys) {
    if (distance >= key) {
      return thresholds[key];
    }
  }
  return undefined; // Or handle the case where no threshold is met (e.g., throw an error)
};

// Total elevation gain (ascent)
const getElevationGain = (points) =>
  points.reduce((gain, p, i) => {
    if (i === 0) return gain;
    const diff = p.ele - points[i - 1].ele;
    return diff > 0 ? gain + diff : gain;
  }, 0);

// Total elevation loss (descent)
const getElevationLoss = (points) =>
  points.reduce((loss, p, i) => {
    if (i === 0) return loss;
    const diff = p.ele - points[i - 1].ele;
    return diff < 0 ? loss + Math.abs(diff) : loss;
  }, 0);

// Min, Max, Average elevation
export const getElevationStatistics = (points, distance = 0) => {
  const eleThreshold = getThreshold(distance, ELEVATION_THRESHOLDS);
  const simpPoints = simplifyPoints(points, eleThreshold);

  const elevations = simpPoints.map((p) => parseInt(p.ele));

  // Calculate Slope Statistics
  // Filter out points with no slope (e.g. first point usually)
  const slopes = points
    .filter((p) => typeof p.slope === "number")
    .map((p) => p.slope);

  let minSlope = 0;
  let maxSlope = 0;
  let avgSlope = 0;

  if (slopes.length > 0) {
    minSlope = Math.min(...slopes);
    maxSlope = Math.max(...slopes);
    // Calculate average using absolute values to represent "average steepness"
    const sumAbsSlope = slopes.reduce((sum, s) => sum + Math.abs(s), 0);
    avgSlope = parseFloat((sumAbsSlope / slopes.length).toFixed(1));
  }

  return {
    start: elevations[0],
    end: elevations[elevations.length - 1],
    lowest: Math.min(...elevations),
    highest: Math.max(...elevations),
    /* average: parseInt(
      elevations.reduce((a, b) => a + b, 0) / elevations.length
    ),*/
    descent: parseInt(getElevationLoss(simpPoints)),
    ascent: parseInt(getElevationGain(simpPoints)),
    minSlope: minSlope,
    maxSlope: maxSlope,
    avgSlope: avgSlope,
  };
};
